// Work planning routes
export default [
  {
    path: 'work-planning',
    name: 'workPlanning',
    component: () =>
      import(
        /* webpackChunkName: "workPlanning" */ '../views/workPlanning/WorkPlanning.vue'
      ),
    meta: {
      tabbable: true,
      tableKeys: [],
      filterKeys: [],
      formKeys: ['workPlanning'],
      routePermissions: ['workPlanningManage'],
    },
  },
];
